<template>
    <v-app>
        <v-layout row justify-center class="previewDialog">
            <v-dialog v-model="dialog" width="392" height="667" persistent >
                <v-card>
                    <div class="mx-0 closeBtn" icon @click="close"><v-icon style=" color: rgba(255,255,255,1);">close</v-icon></div>
                    <v-card-text class="dialogtext">
                        <div class="bookInfo">
                            <div class="book-detail-horizontal-wrap" >
                                <div class="book" style="aspectRatio :1">
                                    <img :src="model.contentsDetail.thumbnail_url"  class="img-full">
                                </div>
                                <div class="book-info">
                                    <h4 class="book-title">{{model.title}}</h4>

                                    <div class="detail-info">
                                        <p class="gray--text mt10" >
                                            {{model.user.nickname}}
                                        </p>
                                        <p class="gray--text mt1">{{model.created_at | date}}</p>
                                        <div class="align-center mt3">
                                            <span class="mr-1"><div class="exa-chat-view"></div>{{model.reply_count}}</span>
                                            <span><div class="exa-like-view"></div>{{model.likes_count}}</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div v-html="model.content" padding class="book-content"></div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>
</template>

<script>

	import { Contents } from '../../service/model/Contents'
    export default{

        components: {

        },

        data: () => ({
            dialog: false,
	        model: new Contents(),

        }),
        created() {

        },
        methods: {
            openDialog(contents) {
                this.dialog = true

                this.model =contents

            },
            close() {
                this.dialog = false
            },
        }
    }


</script>


<style lang="scss">
    @import "../../../src/assets/styles/common/variables";
    .closeBtn{
        position: fixed;
        z-index: 999;
        background: rgba(0,0,0,0.5);
        border-radius: 0;
        color:#fff!important;
        padding: 3px;
        cursor: pointer;

    }
    .previewDialog{
        .v-dialog:not(.v-dialog--fullscreen) {
            max-height: 100%;
        }
    }

    .v-dialog:not(.v-dialog--fullscreen){
        /*max-height: 667px;
        min-height: 667px;*/

    }
    .dialogtext {

    }

    .book-detail-horizontal-wrap {
        @extend .flex-container;
        position: relative;
        top: 0;
        left: 0;
        text-align: left;

        border-bottom: 1px solid #000;

        .book {
            flex: 0 0 80px;
            margin-right: 10px;

            img {
                border: 1px solid #eaeaea;
                width: 100%;
            }
        }
        .gray--text{
            color: #7f7f7f;
            font-size: 0.95rem !important;
            font-weight: normal !important;
        }
        .book-info {
            position: relative;
            top:0;
            left:0;
            width: 100%;

            .book-title {
                margin: 0;
                margin-bottom: 6px;
                text-align: left;
                font-size: 1.7rem;
                overflow: hidden;
                width: 100%;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                text-overflow: ellipsis;
                line-height: 1.3rem !important;
                font-weight: 700 !important;
            }

            .detail-info {
                position: absolute;
                left:0;
                bottom:0;
            }
        }
    }

    .book-content {
        white-space: pre-line;
        line-height: 185%;
        text-align: justify;
        font-size: 0.9rem;
        letter-spacing: -0.5pt;
        font-weight: 400 !important;
        color:#000;
        font-family: 'KoPub돋움체 Medium' !important;
    }

    .tags-container {
        padding: 16px 0;
        border-top: 1px solid #eaeaea;
        border-bottom: 1px solid #eaeaea;

        .tag:first-child {
            margin-left: 16px;
        }
    }
    .exa-chat-view {
        position: relative;
        display: inline-block;
        left: 0;
        margin: 0;
        vertical-align: middle;
        $sz: 15px;
        width: $sz;
        height: $sz;
        min-width: 20px !important;
        background: url("../../../src/assets/icon/chat.svg") no-repeat 50% 50%;
        background-size: contain;
    }
    .exa-like-view{
        position: relative;
        display: inline-block;
        left: 0;
        margin: 0;
        vertical-align: middle;
        $sz: 15px;
        width: $sz;
        height: $sz;
        min-width: 20px !important;
        background: url("../../../src/assets/icon/like.svg") no-repeat 50% 50%;
        background-size: contain;
    }
</style>

